/**
 * A new release that is downloaded and waiting to be applied.
 *
 * Applying it means a full reload, and the service worker used to do that
 * the moment it noticed a deploy, up to a minute into whatever someone was
 * typing. A phone app never restarts under your thumb. Inside the app the
 * update now waits for the next page change (the shell calls
 * `applyPendingUpdate` between pages), where a reload costs nothing: the
 * page being left is gone either way.
 *
 * Not on hide: a phone app keeps a half-filled form while you switch to
 * another app to copy a number, so a reload in the background would lose it.
 */
let apply: (() => boolean) | null = null;

/** Where nothing is being edited, an update can be taken at once. */
const isInsideApp = () => window.location.pathname.startsWith('/dashboard');

/**
 * Hand over the function that applies the update. It returns false when it
 * declined (the reload guard is spent), true when a reload is under way.
 */
export function deferUpdate(applyUpdate: () => boolean) {
  apply = applyUpdate;
  if (!isInsideApp()) applyPendingUpdate();
}

/** Take a waiting update now. True when a reload has started. */
export function applyPendingUpdate(): boolean {
  if (!apply) return false;
  const run = apply;
  apply = null;
  return run();
}
